// extracted by mini-css-extract-plugin
module.exports = {"highlighter":"roomSelectionView_highlighter__2qNf8","wrapper":"roomSelectionView_wrapper__3zfYe","xlBlock":"roomSelectionView_xlBlock__2RzSO"};